import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { interval } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
//import * as jsPDF from 'jspdf';
import {jsPDF} from 'jspdf';

@Component({
  selector: 'app-audit-report',
  templateUrl: './audit-report.component.html',
  styleUrls: ['./audit-report.component.scss']
})
export class AuditReportComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  searchText: string;
  FromDate: any;
  ToDate: any;
  Type: string;
  sOnboardingId: string;
  ExportData=[] as any;
  ShownExport:boolean=true;

  displayedColumnsInvItemDis: string[] = ['sno', 'bE_No', 'invoiceNo', 'invoiceDate', 'partNo','partNoPOA', 'description','shortDescriptionPOA', 'longDescription','longDescriptionPOA', 'unitPrice','unitPricePOA', 'unit','unitPOA', 'cnotn','cnotnPOA', 'cntonSlNo','cnotnSlNoPOA', 'cusDtyRt','cusDtyRtPOA', 'antiDmNotn','antiDmNotnPOA', 'antiDmNotnSlno','antiDmNotnSlNoPOA', 'antiDmUnitPrice','antiDmNotm1UnitPricePOA', 'enotn','enotnPOA', 'entonSlNo','enotnSlNoPOA', 'excDtyRt','exdtyRtPOA', 'hcvdRt','hcvdRtPOA', 'eccRt','eccRtPOA', 'sheccRt','sheccRtPOA', 'cecRt','cecRtPOA', 'cshecRt','csheRtPOA', 'swsRt','swsRtPOA', 'igstNotn','igstNotnPOA', 'igstNothSlNo','igstNotnSlNoPOA', 'igstRt','igstRtPOA', 'gstcNotn','gstcNotnPOA', 'gstcNotnSlNo','gstcNotnSlNoPOA', 'gstcRt','gstcRtPOA'];
  dataSourceInvItemDis: MatTableDataSource<any[]>;
  @ViewChild('TableInvItemDisPaginator', { static: true }) tableInvItemDisPaginator: MatPaginator;
  @ViewChild('TableInvItemDisSort', { static: true }) tableInvItemDisSort: MatSort;
  @ViewChild('TABLE8') table8: ElementRef;
  

  @ViewChild('tblExport') tblExport: ElementRef;

  constructor(private http: HttpClient) { }
  

  ngOnInit(): void {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      
    }
    this.Type="0";
  }

  ViewReport() {debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Report/GetAuditOutputReport', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSourceInvItemDis = new MatTableDataSource(data);
        this.dataSourceInvItemDis.data = data;
        this.dataSourceInvItemDis.paginator = this.tableInvItemDisPaginator;
        this.dataSourceInvItemDis.sort = this.tableInvItemDisSort;

        this.ExportData=data;
      });
      
    //this.ExportData
  }
  applyFilterInvItemDis(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceInvItemDis.filter = filterValue;
  }

  exportexcelInvoiceItemDis(): void {
    debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return ;
    }
    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return ;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return ;
    }
    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Report/GetAuditOutputReport', { params: params }).toPromise().then(
      (data: any) => {
        //debugger;
        this.ExportData=data;
        let element = document.getElementById('tblExport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'AuditReport');
    
        /* save to file */
        XLSX.writeFile(wb, "AuditReport.xlsx");
      })
      
     

  }

  public generatePdf(): void {   
    debugger;
    const doc = new jsPDF();       
    const specialElementHandlers = {
      '#editor': function (element, renderer) {
        return true;
      }
    };
    const pdfTable = this.tblExport.nativeElement;
    doc.fromHTML(pdfTable.innerHTML, 1, 15, {
      width: 80,
      'elementHandlers': specialElementHandlers
    });
    doc.save('Country.pdf');
  }
}
